const $ = require('jquery');

window.onresize = function() {
  document.body.height = window.innerHeight;
}
window.onresize();

(function(){

  var doc = document.documentElement;
  var w = window;

  var prevScroll = w.scrollY || doc.scrollTop;
  var curScroll;
  var direction = 0;
  var prevDirection = 0;
  var scroll = $(window).scrollTop();

 

  var header = document.getElementById('site-header');

  var checkScroll = function() {

    /*
    ** Find the direction of scroll
    ** 0 - initial, 1 - up, 2 - down
    */

    curScroll = w.scrollY || doc.scrollTop;
    if (curScroll > prevScroll) { 
      //scrolled up
      direction = 2;
    }
    else if (curScroll < prevScroll) { 
      //scrolled down
      direction = 1;
    }

    if (direction !== prevDirection) {
      toggleHeader(direction, curScroll);
    }
    
    prevScroll = curScroll;
  };


  var toggleHeader = function(direction, curScroll) {
    if (direction === 2 && curScroll > 100) { 
      //header.classList.remove('header-bg');
      header.classList.add('hide');
      prevDirection = direction;
    }
    else if (direction === 1) {
      header.classList.remove('hide');
      //header.classList.add('header-bg');
      prevDirection = direction;
    }
  };
  
  window.addEventListener('scroll', checkScroll);

})();


// WEBPACK FOOTER //
// ./wp/wp-content/themes/brockmeyer-chisel/src/scripts/additional/hideheader.js